import { Button } from '@gravity-ui/uikit';
import { useLazyDownloadSectionRatingsAvarageReportQuery } from 'store/api';
import styles from './styles.module.scss';
import { useSectionsRatingsAverageDataQuery } from 'store/api/private/charts-api/chart-api-data';
import { Bar } from 'react-chartjs-2';
import { ChartOptions } from 'chart.js';
import 'chart.js/auto';

interface SectionRating {
	sectionName: string;
	averageExecutionMark1: number;
	averageSatisfactionMark1: number;
	averageExecutionMark2: number;
	averageSatisfactionMark2: number;
}

export const SectionRatingsAverageReport = () => {
	const [trigger, { isFetching }] = useLazyDownloadSectionRatingsAvarageReportQuery();

	const {
		data: sectionRatingsAvarageData,
		isLoading,
		error,
	} = useSectionsRatingsAverageDataQuery(null, {
		refetchOnMountOrArgChange: true,
		refetchOnFocus: true,
		refetchOnReconnect: true,
	});

	// Создаем данные для каждого раздела отдельно
	const createChartDataForSection = (section: SectionRating) => ({
		labels: [
			'Средняя оценка удовлетворенности - повторная оценка',
			'Средняя оценка удовлетворенности - первая оценка',
			'Средняя оценка выполнения - повторная оценка',
			'Средняя оценка выполнения - первая оценка',
		],
		datasets: [
			{
				label: section.sectionName,
				data: [
					section.averageSatisfactionMark2,
					section.averageSatisfactionMark1,
					section.averageExecutionMark2,
					section.averageExecutionMark1,
				],
				backgroundColor: ['#FF69B4', '#FF4500'],
				borderWidth: 1,
				barThickness: 15,
			},
		],
	});

	const options: ChartOptions<'bar'> = {
		indexAxis: 'y' as const,
		responsive: true,
		maintainAspectRatio: false,
		scales: {
			x: {
				beginAtZero: true,
				max: 5,
				title: {
					display: true,
					text: 'Оценка',
					font: {
						size: 14,
					},
				},
				ticks: {
					font: {
						size: 12,
					},
				},
			},
			y: {
				title: {
					display: false,
				},
				ticks: {
					font: {
						size: 12,
					},
					maxRotation: 0,
					minRotation: 0,
					crossAlign: 'center',
					callback: function (value: any, index: number) {
						const label = this.getLabelForValue(value);
						// Разбиваем длинные лейблы на части
						if (label && label.length > 35) {
							const words = label.split(' ');
							const lines = [];
							let currentLine = '';

							for (const word of words) {
								if ((currentLine + word).length > 35) {
									if (currentLine) lines.push(currentLine.trim());
									currentLine = word + ' ';
								} else {
									currentLine += word + ' ';
								}
							}
							if (currentLine) lines.push(currentLine.trim());

							return lines;
						}
						return label;
					},
				},
			},
		},
		plugins: {
			legend: {
				display: false,
			},
			title: {
				display: false,
			},
		},
	};

	const handleDownload = async () => {
		try {
			const result = await trigger().unwrap();
			const url = window.URL.createObjectURL(result);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'Отчёт по разделам и средним оценкам.xlsx');
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Ошибка при скачивании файла:', error);
		}
	};

	return (
		<div className={styles.chart}>
			<h2>Данные по разделам и средним оценкам</h2>
			<div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '30px', marginBottom: '50px' }}>
				{sectionRatingsAvarageData?.map((section, index) => (
					<div key={section.sectionName} style={{ width: '100%', height: '300px' }}>
						<h3 style={{ textAlign: 'center', marginBottom: '0px' }}>{section.sectionName}</h3>
						<Bar data={createChartDataForSection(section)} options={options} />
					</div>
				))}
			</div>
			<Button onClick={handleDownload} loading={isFetching} size="xl">
				{isFetching ? 'Скачивание...' : 'Скачать отчёт по разделам и средним оценкам'}
			</Button>
		</div>
	);
};
